export const getExperiences = (state: any) => state.experiences.data;
export const getExperiencesCategory = (state: any) =>
  state.experiences.category;
export const getExperiencesSearch = (state: any) => state.experiences.search;
export const getExperiencesLoading = (state: any) => state.experiences.loading;
export const getExperiencesSlowLoading = (state: any) =>
  state.experiences.slowLoading;
export const getExperiencesError = (state: any) => state.experiences.error;
